<template>
    <div class="createActive">
        <el-dialog
            :title="title"
            :close-on-click-modal="false"
            :visible.sync="dialogActivityDateVisible"
            v-if="dialogActivityDateVisible"
            append-to-body
            class="dialogActivityDateVisible"
        >
            <div class="dialogContent">
                <div class="titleTop">集采活动基础信息</div>
                <el-form
                    :model="form"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="140px"
                >
                    <el-form-item label="活动名称" prop="activityName" ref="activityName">
                        <el-input
                            v-model="form.activityName"
                            maxlength="20"
                            show-word-limit
                            placeholder="请输入活动名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="参与商品分类" prop="categoryUuid" ref="categoryUuid">
                        <el-select v-model="form.categoryUuid" filterable
                                   @change="copyOptionLabel"
                                   placeholder="请选择">
                            <el-option
                                label="全部"
                                value="all">
                            </el-option>
                            <el-option
                                v-for="item in categoryList"
                                :key="item.uuid"
                                :label="item.name"
                                :value="item.uuid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <div class="activeBanner">
                        <!-- 活动广告图 -->
                        <!--<el-form-item
                            label="活动广告图"
                            prop="adUrl"
                            ref="adUrl"
                        >
                            <div style="display: flex" v-loading="thumbnailLoading">
                                <el-upload
                                    action="/service-center/upload/file/single"
                                    :show-file-list="false"
                                    :headers="headers"
                                    :on-success="handleAvatarSuccess"
                                    :before-upload="beforeAvatarUpload"
                                    class="thumbnailClass"
                                >
                                    <div class="avatar" v-if="!form.adUrl">
                                        <i class="el-icon-plus"></i>
                                    </div>
                                    <div>
                                        <el-image
                                            v-if="form.adUrl"
                                            :src="form.adUrl"
                                            class="thumbnailClass"
                                            style="
                        border: solid 1px #ececec;
                        background-color: #f9f9f9;
                      "
                                        >
                                        </el-image>
                                    </div>
                                </el-upload>
                            </div>
                            <p class="imgsMess">请上传698*360的图片,2M以内</p>
                        </el-form-item>-->
                        <!-- 活动banner -->
                        <el-form-item
                            label="活动banner"
                            prop="bannerUrl"
                            ref="bannerUrl"
                        >
                            <div style="display: flex" v-loading="thumbnailLoading2">
                                <el-upload
                                    action="/service-center/upload/file/single"
                                    :show-file-list="false"
                                    :headers="headers"
                                    :on-success="handleAvatarSuccess2"
                                    :before-upload="beforeAvatarUpload2"
                                    class="thumbnailClass"
                                >
                                    <div class="avatar" v-if="!form.bannerUrl">
                                        <i class="el-icon-plus"></i>
                                    </div>
                                    <div>
                                        <el-image
                                            v-if="form.bannerUrl"
                                            :src="form.bannerUrl"
                                            class="thumbnailClass"
                                            style="
                                                border: solid 1px #ececec;
                                                background-color: #f9f9f9;
                                            "
                                        >
                                        </el-image>
                                    </div>
                                </el-upload>
                            </div>
                            <p class="imgsMess">请上传1920*400的图片,2M以内</p>
                        </el-form-item>
                    </div>
                    <el-form-item label="活动时间" prop="inputDate" ref="inputDate">
                        <el-date-picker
                            v-model="form.inputDate"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <div class="titleTop">活动详情</div>
                    <el-form-item
                        label="活动详情"
                        prop="activityContent"
                        ref="activityContent"
                    >
                        <editor
                            id="editor"
                            v-model="form.activityContent"
                            :init="editorInit"
                        ></editor>
                    </el-form-item>
                    <el-form-item class="submitButtonClass">
                        <el-button @click="submit('save')">保存</el-button>
                        <el-button type="primary" @click="submit('up')">发布</el-button>
                        <el-button @click="dialogActivityDateVisible = false"
                        >取消
                        </el-button
                        >
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getShopCategoryList,
        uploadFile,
        activitiesListByPage,
        activitiesList,
        getActivitiesDetails,
        saveActivities,
        publishActivities,
        delActivities,
        activitiesStoreListByPage,
        activitiesStoreList,
        activitiesGoodsListByPage,
        activitiesGoodsList,
        getActivitiesGoodsDetails,
        auditActivitiesGoods,
        activitiesStorePointListByPage,
        activitiesStorePointList,
        exchangeActivitiesStore
    } from "../../../utils/interface";

    export default {
        name: "createActive",
        data() {
            return {
                title: "",
                dialogActivityDateVisible: false,
                form: {
                    activityName: "",
                    categoryUuid: "",
                    categoryName: "",
                    adUrl: "",
                    bannerUrl: "",
                    inputDate: [],
                    exchangeRate: "",
                    activityContent: "",
                    activityType: "CENTRAL",
                },
                rules: {
                    activityName: [
                        {required: true, message: "请输入活动名称", trigger: "blur"},
                    ],
                    categoryUuid: [
                        {required: true, message: "请选择商品分类", trigger: "blur"},
                    ],
                    // adUrl: [
                    //     {required: true, message: "请上传活动广告图", trigger: "change"},
                    // ],
                    bannerUrl: [
                        {required: true, message: "请上传活动banner", trigger: "change"},
                    ],
                    inputDate: [
                        {required: true, message: "请选择活动时间", trigger: "blur"},
                    ],
                    exchangeRate: [
                        {required: true, message: "请输入现金集采规则", trigger: "blur"},
                    ],
                    activityContent: [
                        {required: true, message: "请输入活动详情", trigger: "blur"},
                    ],
                },
                headers: {
                    Authorization:
                        "Bearer " + window.sessionStorage.getItem("api_access_token"),
                },
                thumbnailLoading: false,
                thumbnailLoading2: false,
                editorInit: {
                    //编辑框的配置项目
                    selector: "#editor",
                    /* 语言配置，将其转化为中文，如果main.js配置不起作用，也可在这里配置 */
                    language_url: "/static/tinymce/langs/zh_CN.js",
                    language: "zh_CN",
                    plugins: "image table imagetools",
                    images_upload_handler: (blobInfo, success, failure) => {
                        var formData;
                        formData = new FormData();
                        formData.append("file", blobInfo.blob(), blobInfo.filename());

                        // 上传接口
                        uploadFile(formData).then((res) => {
                            success(res.url);
                        });
                    },
                    /* 菜单栏配置 */
                    menubar: false, //隐藏菜单栏
                    font_formats:
                        "Arial=arial,helvetica,sans-serif; 宋体=SimSun;  微软雅黑=Microsoft Yahei; Impact=impact,chicago;", //字体
                    fontsize_formats: "11px 12px 14px 16px 18px 24px 36px 48px 64px 72px", //文字大小

                    /* 工具栏配置 */
                    toolbar:
                        "bold italic underline strikethrough  | fontselect | fontsizeselect | formatselect \
                          | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist \
                          | outdent indent blockquote | removeformat| undo redo | link unlink image media pageembed \
                          insertdatetime table  hr pagebreak codesample | code fullscreen preview", //工具条
                    /* 其它配置 */
                    branding: false, //水印
                    elementpath: false, //底部元素路径
                    paste_data_images: true, //允许粘贴图片
                    height: 300, //编辑框高度
                    statusbar: false, // 隐藏编辑器底部的状态栏
                    toolbar_mode: "wrap",
                },
                categoryList: [],
            };
        },
        mounted() {
            this.getCategoryList();
        },
        methods: {
            getCategoryList() {
                let params = {
                    parentUuid: "",
                    grade: "1",
                    type: 'PLATFORM',
                    current: 1,
                    pageSize: 100,
                }
                getShopCategoryList(params).then((res) => {
                    this.categoryList = res.list;
                });

            },
            copyOptionLabel(value) {
                if(value == "all"){
                    this.form.categoryName = "全部";
                }else{
                    let obj = {};
                    obj = this.categoryList.find((item) => {
                        return item.uuid === value;
                    });
                    this.form.categoryName = obj.name;
                }
            },
            init(type, data) {
                type == "add" ? (this.title = "创建集采活动") : (this.title = "编辑集采活动");
                if (type == "add") {
                    this.form = {
                        activityName: "",
                        categoryUuid: "",
                        categoryName: "",
                        adUrl: "",
                        bannerUrl: "",
                        inputDate: [],
                        exchangeRate: "",
                        activityContent: "",
                        activityType: "CENTRAL",
                    };
                    this.$nextTick(() => {
                        if (this.$refs.ruleForm) {
                            this.$refs.ruleForm.clearValidate()
                        }
                    })
                } else if (type == "edit") {
                    getActivitiesDetails(data.uuid).then((res) => {
                        if (res.success) {
                            this.form = {
                                uuid: res.data.uuid,
                                activityName: res.data.activityName,
                                categoryUuid: res.data.categoryUuid,
                                categoryName: res.data.categoryName,
                                adUrl: res.data.adUrl,
                                bannerUrl: res.data.bannerUrl,
                                inputDate: [],
                                exchangeRate: res.data.exchangeRate,
                                activityContent: res.data.activityContent,
                                activityType: "CENTRAL",
                                startTime: res.data.startTime,
                                endTime: res.data.endTime,
                            };
                            if (this.form.startTime) {
                                this.form.inputDate.push(new Date(this.form.startTime));
                            }
                            if (this.form.endTime) {
                                this.form.inputDate.push(new Date(this.form.endTime));
                            }
                        }
                    });
                }
                this.dialogActivityDateVisible = true;
            },
            // 保存发布
            submit(type) {
                this.$refs.ruleForm.validate((valid, obj) => {
                    if (this.form.inputDate.length > 0) {
                        this.form.startTime = this.timeDate(this.form.inputDate[0]);
                        this.form.endTime = this.timeDate(this.form.inputDate[1]);
                    }
                    if (type == 'save') {
                        this.$refs.ruleForm.validateField(['activityName'], (Error) => {
                            if (!Error) {
                                //执行
                                saveActivities(this.form).then((res) => {
                                    if (res.success) {
                                        this.$message.success(res.message);
                                        this.dialogActivityDateVisible = false;
                                        this.$emit('refresh');
                                    }
                                });
                            }else{
                                let dom = this.$refs['activityName'];
                                dom.$el.scrollIntoView({
                                    //滚动到指定节点
                                    block: "center", //值有start,center,end，nearest，当前显示在视图区域中间
                                    behavior: "smooth", //值有auto、instant,smooth，缓动动画（当前是慢速的）
                                });
                            }
                        });
                    } else if (type == 'up') {
                        if (valid) {
                            publishActivities(this.form).then((res) => {
                                if (res.success) {
                                    this.$message.success(res.message);
                                    this.dialogActivityDateVisible = false;
                                    this.$emit('refresh');
                                }
                            });
                        } else {
                            for (let i in obj) {
                                let refsMess = i;
                                let dom = this.$refs[refsMess];
                                dom.$el.scrollIntoView({
                                    //滚动到指定节点
                                    block: "center", //值有start,center,end，nearest，当前显示在视图区域中间
                                    behavior: "smooth", //值有auto、instant,smooth，缓动动画（当前是慢速的）
                                });
                            }
                        }
                    }
                });
            },
            // 活动广告图
            handleAvatarSuccess(res, file) {
                this.form.adUrl = res.url;
                this.thumbnailLoading = false;
            },
            // 活动banner
            handleAvatarSuccess2(res, file) {
                this.form.bannerUrl = res.url;
                this.thumbnailLoading2 = false;
                this.$refs.ruleForm.validateField('bannerUrl');
            },
            beforeAvatarUpload(file) {
                this.thumbnailLoading = true;
                const isJPG = file.type.indexOf("image") !== -1;
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.thumbnailLoading = false;
                    this.$message.warning("上传图片只能是图片格式!");
                    this.thumbnailLoading = false;
                }
                if (!isLt2M) {
                    this.thumbnailLoading = false;
                    this.$message.warning("上传图片大小不能超过 2MB!");
                    this.thumbnailLoading = false;
                }
                return isJPG && isLt2M;
            },
            beforeAvatarUpload2(file) {
                this.thumbnailLoading2 = true;
                const isJPG = file.type.indexOf("image") !== -1;
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.thumbnailLoading2 = false;
                    this.$message.warning("上传图片只能是图片格式!");
                    this.thumbnailLoading2 = false;
                }
                if (!isLt2M) {
                    this.thumbnailLoading2 = false;
                    this.$message.warning("上传图片大小不能超过 2MB!");
                    this.thumbnailLoading2 = false;
                }
                const isSize = new Promise(function(resolve, reject){
                    let width = 1920;
                    let height = 400;
                    let _URL = window.URL || window.webkitURL;
                    let img = new Image();
                    img.onload = function(){
                    let valid = img.width == width && img.height == height 
                    // let valid = img.width / img.height === 1.67;
                    valid ? resolve() : reject();
                    }
                    img.src = _URL.createObjectURL(file);
                }).then(()=>{
                    return file;
                }, ()=>{
                    this.$message({
                      message:'上传图片尺寸为1920*400'
                    });
                    this.thumbnailLoading2 = false;

                    return Promise.reject()
                    return false;//必须加上return false; 才能阻止
                })
                return isJPG && isLt2M && isSize;
            },
            timeDate(value) {
                let date = new Date(value);
                let y = date.getFullYear();
                let MM = date.getMonth() + 1;
                MM = MM < 10 ? "0" + MM : MM;
                let d = date.getDate();
                d = d < 10 ? "0" + d : d;
                let h = date.getHours();
                h = h < 10 ? "0" + h : h;
                let m = date.getMinutes();
                m = m < 10 ? "0" + m : m;
                let s = date.getSeconds();
                s = s < 10 ? "0" + s : s;
                return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
            },
        },
    };
</script>

<style lang="less" scoped>
/deep/.el-dialog {
    width: 66%;
}
    .createActive {
        .dialogActivityDateVisible {
            /deeep/ .el-dialog__body {
                padding-left: 30px !important;
                padding-right: 30px !important;
            }
        }
    }

    .dialogContent {
        /deep/ .el-upload-list--picture-card .el-upload-list__item {
            width: 590px;
            height: 300px;
        }

        /deep/ .el-upload--picture-card {
            width: 590px;
            height: 300px;
            line-height: 300px;
        }

        /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
            width: 590px;
            height: 300px;
        }

        /deep/ .el-form-item {
            margin-right: 90px;
        }

        .titleTop {
            font-size: 20px;
            margin-bottom: 26px;
            padding-left: 48px;
            border-top: 1px solid #efefef;
            padding-top: 30px;

            &:nth-of-type(1) {
                border-top: none;
                padding-top: 0;
            }
        }

        // 活动封面和banner
        .activeBanner {
            display: flex;
        }

        .thumbnailClass {
            width: 222px;
            height: 125px;

            .avatar {
                width: 222px;
                height: 125px;
                border: 1px dashed #ddd;
                border-radius: 4px;
                line-height: 125px;
                font-size: 50px;
            }
        }

        .imgsMess {
            margin: 0;
            margin-left: 10px;
            color: #a1a1a1;
        }

        .submitButtonClass {
            /deep/ .el-form-item__content {
                margin-left: 0 !important;
                text-align: center;

                button {
                    padding: 0;
                    width: 120px;
                    height: 35px;
                    line-height: 35px;
                    border-radius: 6px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/collectManage/collectDialog/createActivities.vue